export function normalizeCategoryRow(raw) {
  if (!raw || typeof raw !== "object") return null;
  const item =
    raw.attributes && typeof raw.attributes === "object" ? raw.attributes : raw;
  const id = item.id;
  if (id == null) return null;
  const nm = item.name;
  let label = "";
  if (nm && typeof nm === "object") label = String(nm.en || nm.ar || "");
  else if (typeof nm === "string") label = nm;
  if (!label) label = String(item.name_en || item.name_ar || `#${id}`);
  return { id, label };
}
